import * as React from 'react';
const SvgRobotRefresh = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.094 5.5a.625.625 0 01-.58-.855L2.064.725A.625.625 0 013.163.602l.75 1.107A7.5 7.5 0 11.631 9.405a.834.834 0 111.638-.31A5.833 5.833 0 104.85 3.09l.973 1.434a.625.625 0 01-.517.976H1.093h.001z"
            fill="currentColor"
        />
    </svg>
);
export default SvgRobotRefresh;
